module.exports = __webpack_public_path__ + "static/media/job_bathroom.11235ad3.svg";